import React, { Component } from 'react';
import style from './style/reportoverlay.scss';

export default class ReportOverlay extends Component {
    render() {
        const { reportOverlayVisible, classes, children } = this.props;

        return (
            <div
                id="report_detail"
                className={ `
                    ${style.reportoverlay}
                    ${classes.root ? classes.root : ''}
                    ${reportOverlayVisible ? style.reportoverlay__open : ''}
                `}
            >
                <section>
                    { children }
                </section>
            </div>
        );
    }
}
